import { isUserProfile, UserProfile } from '../entities/user-profile';
import { http } from '../http';

export async function getUserInfo() {
	const userProfile = await http.get<UserProfile>('/user');
	if (isUserProfile(userProfile)) {
		return userProfile;
	} else {
		throw TypeError;
	}
}
